import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Save from "@material-ui/icons/Save";
import Close from "@material-ui/icons/Close";
import DeleteModalRest from "../AddNewPersDecision/pages/delete-modal-rest";

const ProjectPreRestrictions = ({
  formData,
  name,
  isPre,
  setRestrictionsData,
}) => {
  const [restrictions, setRestrictions] = useState([]);
  const [previousRestrictions, setPreviousRestrictions] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deletedRow, setDeletedRow] = useState(null);

  useEffect(() => {
    setRestrictions([...(formData[name] || [])]);
    setPreviousRestrictions(JSON.parse(JSON.stringify(formData[name] || [])));
  }, [formData[name]]);

  const handleRowSelection = (event, index) => {
    const _restrictions = restrictions.map((restriction, i) => {
      return i === index
        ? {
            ...restriction,
            isExistingRestrictions: event.target.checked,
            isEdit: false,
            isAddedRestrictions: false,
          }
        : restriction;
    });

    setRestrictions(_restrictions);
    setRestrictionsData(_restrictions, name);
  };

  const handleRowChange = (event, index) => {
    const { name, value } = event.target;
    const _restrictions = restrictions.map((restriction, i) => {
      return i === index ? { ...restriction, [name]: value } : restriction;
    });

    setRestrictions(_restrictions);
  };

  const handleRowSave = (index) => {
    toggleEdit(index, false);
  };

  const handleRowCancel = (index, isEdit) => {
    const _restrictions = restrictions.map((restriction, i) => {
      return i === index
        ? { ...previousRestrictions[index], isEdit }
        : restriction;
    });

    setRestrictions(_restrictions);
    setRestrictionsData([..._restrictions], name);
  };

  const toggleEdit = (index, isEdit) => {
    const _restrictions = restrictions.map((restriction, i) =>
      i === index ? { ...restriction, isEdit } : restriction
    );

    setRestrictions(_restrictions);
    setRestrictionsData(_restrictions, name);
  };

  const handleDelete = (index) => {
    setDeletedRow(index);
    setShowDelete(true);
  };

  const handleDeleteSubmit = () => {
    const _restrictions = restrictions.filter((_, i) => i !== deletedRow);

    setRestrictions(_restrictions);
    setShowDelete(false);
    setDeletedRow(null);
    setRestrictionsData(_restrictions, name);
  };

  const handleDeleteCancel = () => {
    setShowDelete(false);
    setDeletedRow(null);
  };

  return (
    <>
      {restrictions &&
        restrictions.map(
          (
            {
              restrictionsName,
              restrictionsDescription,
              isEdit,
              isExistingRestrictions,
              isAddedRestrictions = isExistingRestrictions,
            },
            index
          ) => (
            <div>
              <div
                className="checkboxContainer"
                style={{
                  justifyContent: "space-between",
                  marginBottom: "0px",
                  marginTop: 10,
                }}
              >
                <div style={{ display: "flex", height: 0 }}>
                  <div>
                    <input
                      type="checkbox"
                      aria-label={restrictionsName}
                      className={"checkboxfield"}
                      style={{ height: 15, width: 15, marginTop: 5 }}
                      id={restrictionsName}
                      name={`${name}_restriction`}
                      checked={isExistingRestrictions}
                      onChange={(event) => handleRowSelection(event, index)}
                    />
                  </div>
                  <div>
                    {(!isEdit || isPre) && (
                      <label
                        className={"checkboxLabel"}
                        htmlFor={"input"}
                        style={{ marginBottom: 0, marginLeft: 10 }}
                      >
                        {restrictionsName}
                      </label>
                    )}
                    {isEdit && !isPre && isExistingRestrictions && (
                      <input
                        type="text"
                        name="restrictionsName"
                        className="form-control"
                        value={restrictionsName}
                        onChange={(event) => handleRowChange(event, index)}
                      />
                    )}
                  </div>
                </div>
                {isEdit ? (
                  <div>
                    <Button
                      style={{
                        textTransform: "capitalize",
                        padding: 0,
                      }}
                      onClick={() => handleRowSave(index)}
                    >
                      <Save
                        style={{
                          color: "#0F5AF0",
                          marginRight: "5px",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      Save
                    </Button>
                    <Button
                      style={{
                        marginLeft: "10px",
                        textTransform: "capitalize",
                      }}
                      className="test"
                      onClick={() => handleRowCancel(index, false)}
                    >
                      <Close
                        style={{
                          color: "#999999",
                          marginRight: "5px",
                          height: "18px",
                          width: "18px",
                        }}
                      />{" "}
                      Cancel
                    </Button>
                  </div>
                ) : (
                  <div style={{ display: "flex", height: 0 }}>
                    {!isPre ? (
                      <>
                        <Button
                          style={{
                            textTransform: "capitalize",
                          }}
                          onClick={() =>
                            isExistingRestrictions && toggleEdit(index, true)
                          }
                          disabled={!isExistingRestrictions}
                        >
                          <Edit
                            style={{
                              color: "rgb(17, 118, 181)" /*"#0F5AF0"*/,
                              marginRight: "5px",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                          Edit
                        </Button>
                        <Button
                          style={{
                            marginLeft: "10px",
                            textTransform: "capitalize",
                          }}
                          className="test"
                          disabled={!isExistingRestrictions}
                          onClick={() => handleDelete(index)}
                        >
                          <Delete
                            style={{
                              color: "#D02F2F",
                              marginRight: "5px",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                          Delete
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
              <div>
                {isExistingRestrictions && isEdit ? (
                  <textarea
                    aria-label="edit restriction description"
                    name="restrictionsDescription"
                    value={restrictionsDescription}
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      padding: "5px",
                    }}
                    onChange={(event) => handleRowChange(event, index)}
                  />
                ) : (
                  <p style={{ fontSize: 14, lineHeight: 1, marginTop: "35px" }}>
                    {restrictionsDescription}
                  </p>
                )}
              </div>
            </div>
          )
        )}
      <DeleteModalRest
        showDelete={showDelete}
        restrictionsName={
          restrictions &&
          restrictions[deletedRow] &&
          restrictions[deletedRow].restrictionsName
        }
        handleDeleteCancel={handleDeleteCancel}
        handleDeleteSubmit={handleDeleteSubmit}
      />
    </>
  );
};

export default ProjectPreRestrictions;
